import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { LocatiiService } from '../locatii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { IAddLocatiePayload, IFormLocatie } from '../locatii.interface';

@Component({
    selector: 'app-add-locatie',
    templateUrl: './add-locatie.component.html',
    styleUrls: ['./add-locatie.component.scss']
})
export class AddLocatieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        id_extern: new FormControl('', [Validators.required]),
        address: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddLocatieComponent>,
        private locatiiService: LocatiiService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_extern, address } = this.form.value as IFormLocatie;
        const payload: IAddLocatiePayload = {
            name,
            id_extern,
            address
        };

        this.locatiiService
            .addLocatii(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
